import { render, staticRenderFns } from "./confirm-invite.vue?vue&type=template&id=196450cb"
import script from "./confirm-invite.vue?vue&type=script&lang=js"
export * from "./confirm-invite.vue?vue&type=script&lang=js"
import style0 from "./confirm-invite.vue?vue&type=style&index=0&id=196450cb&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('196450cb')) {
      api.createRecord('196450cb', component.options)
    } else {
      api.reload('196450cb', component.options)
    }
    module.hot.accept("./confirm-invite.vue?vue&type=template&id=196450cb", function () {
      api.rerender('196450cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/account/confirm-invite.vue"
export default component.exports